module.exports = __webpack_public_path__ + "36b1723dfc1db8b45f41556b47d36a9d.svg";